import React from "react";
import bg from "../imgs/aboutbg.jpg";
import "./About.css";
import abouth1 from "../imgs/abouth1.png"

const About=()=>{
	return(
		<div className="aboutpage">
			<img src={bg} alt="background" className="bgimg" />
			<img src={abouth1} className="abouth1" alt="about"/>
			<div className="footer">
			<p>
				AEROneer website is made for those who are interested in learning more about the aerodynamics of an 
				aircraft. it contains a detailed information on aerodynamics of aircraft. This website is made for those
				the students who wants to know what aeronautical engineering is. With the increase in technology, this field 
				has made some great innovations which intrests the minds of students. For These curious students this website 
				will help them understand some basic concepts. The topics of lift, drag and thrust will be explain using animations 
				which will make it easier and a fun way toi learn. It is not necessary that this website can only be used by the 
				aeronautical engineer, it can be used by the students of any other  field also to gain knowledge about this field.
				<br/>
				<br/>
				<strong>HISTORY OF AERONAUTICAL ENGINEERING:-</strong>
				<br/>
				<br/>
				- The origin of aeronautical engineering is traced back to around late 19th to early 20th century. In december 1903 
				the Wright Brothers perform the first sustained, controlled flight of a powered, heavier than air aircraft. Between 
				the world wars 1 and 2, the field observed some great leaps. A significant development came with the first operational 
				Jet engine powered airplanes which entered service in 1994 towards the end of the second world war.	
			</p>	
			</div>
		</div>
		);
}
export default About;